import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const WorkOrderEdit = lazyLoader(
  () => import("Containers/WorkOrders/WorkOrderEdit/WorkOrderEdit")
);

export const WorkOrderEditPage = () => {
  return (
    <Layout>
      <WorkOrderEdit />
    </Layout>
  );
};
